import React, {useEffect, useState} from "react";
import {Box, Grid, Paper, Tooltip, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {format, parseISO} from "date-fns";
import {clickNewTab} from "../../../utils/utils";
import OSKPI from "../OSKPI";

import IconButton from "@material-ui/core/IconButton/IconButton";
import * as config from "../../../config";
import AutoclaveKPI from "./AutoclaveKPI";
import {useDispatch} from "react-redux";
import {getThotAutoclavesMonitorTenant} from "../../../actions/thotActions";


const useStyles = makeStyles(theme => ({

    mainPlant: {
        display: 'flex',
        flexDirection: 'row',
        flexBasis: 'min-content',
        flexWrap: 'wrap',
       // borderStyle: 'solid',

      //  borderWidth: '1px',
        backgroundColor: '#f5f1f1',
        borderRadius: '5px',


    },
    mainPaper: {
        display: 'flex',
        flexDirection: 'row',
        flexBasis: 'fit-content',
        flexWrap: 'wrap',
      //  borderStyle: 'solid',
      //  borderColor: '#726e6e',
        borderWidth: '1px',
        backgroundColor: '#f5f1f1',
        borderRadius: '5px',


    },
    mainGrid: {
        display: 'flex',
        //flexGrow: 1,
       // backgroundColor: 'red',
        flexDirection: "row",
        flexWrap: "wrap",
        padding: '3px'
    },
    areaTenant: {
      flex: 1,
      flexDirection: "row",
      flexWrap: "nowrap",
       // backgroundColor: 'yellowgreen',
        textAlign: 'center',
        minWidth: '80px',
    flexGrow: 12
  },
    areaKPI: {
        flex: 1,
      //  flexDirection: "row",
        flexWrap: "nowrap",
       // backgroundColor: 'green'
    },
    areaOS: {
        flex: 1,
      //  flexDirection: "row",
        flexWrap: "nowrap",
        flexGrow: 12
       // backgroundColor: 'blue'
    },
    areaEtapas: {
        flex: 1,
        flexDirection: "row",
        flexWrap: "wrap",
       //backgroundColor: 'orange'
    },
    navLogo: {
        margin: '0px',
        // height: "90x",
        width: "160px",
        verticalAlign: 'middle'
    },
}));




const AutoclavePlantGrid = ({ registro, mostrarComm } ) => {
    const classes = useStyles();
    const dispatch = useDispatch();


    const handleRefreshTenant = () => {
        dispatch(getThotAutoclavesMonitorTenant(registro.id))
    }

    if (registro && registro.error) { return (<React.Fragment/>);}

    const imglogo = `/images/tnt${registro.tntId}/logoEmpresaBco.png`;

    console.log("AutoclavePlantGrid", registro);

    const minH = mostrarComm? '620px' : '100px';

    return (
        <Grid container item id={`gridPlantaRoot-${registro.tntId}`} className={classes.mainPlant} style={{  minHeight: {minH}, margin:'3px', padding: '3px' }}  onClick={handleRefreshTenant} >
                <Grid  id={`gridPlantaMainGrid-${registro.tntId}`} className={classes.mainGrid} style={{  margin:'0px',  padding: '0px',
                  //  minHeight:'173px'
                }}  xs={12} md={12} lg={12} xl={12}>

                        <Grid item container style={{ backgroundColor: 'green',  margin:'0px',  padding: '0px' }} xs={12} md={12} xl={12} style={{ }}>
                            <Typography variant={"caption"}>{registro.tDescricao.toUpperCase()}</Typography>
                        </Grid>


                    <Grid container item    className={classes.areaKPI} sx={{ backgroundColor: 'yellow',  padding: '2px',  }} style={{flexDirection: mostrarComm? 'row' : 'column'  }}   xs={12} lg={12} xl={12}>
                        {/*<Grid container item  id={'gridPlanta'} className={classes.areaOS} sx={{ backgroundColor: 'yellow',  padding: '2px', flexDirection: mostrarComm? 'row' : 'column' }}   xs={12} lg={12} xl={12}>*/}
                            { registro.data
                                .sort(function(a, b) {
                                    return a.estabelecimentoId - b.estabelecimentoId || a.codigo - b.codigo;
                                })
                                .map( (a,ix) => {
                                return (<AutoclaveKPI id={a.aId} key={a.aId} autoclave={a} mostrarComm={mostrarComm}  />);
                             })}


                        {/*</Grid>*/}


                    </Grid>
                    {/*<Grid>*/}
                    {/*    <Typography variant={"caption"}>dd/MM/YYYY HH:mm</Typography>*/}
                    {/*</Grid>*/}

                </Grid>

        </Grid >
       );


}

export default AutoclavePlantGrid;
